export class ActivitySpecialPhoto {
  constructor(form) {
    if (form) {
      this.url = form.url;
      this.name = form.name;
      this.type = form.type;
      this.coverImage = form.coverImage;
      if (form.beginTime) {
        this.beginTime = form.beginTime;
      }
      this.cityId = form.cityId ? form.cityId : "";
      this.input = form.type == 1 ? form.url.length ? form.url[0] : '' : ''; // 用于绑定链接
    } else {
      this.clear();
    }
  }

  clear() {
    this.type = 0; // 0-照片，1-链接
    this.url = []; // 活动图片或者链接
    this.input = '';
    this.name = ''; // 活动名称
    this.coverImage = {
      coverPhoto: '', // 封面
      shareCardImage: '', //  分享卡片图片
    };
  }
}
